import React, {Component} from "react";
import _ from "i18n";

export default class RegistrationCAFilter extends Component {

  render() {
    const {type, legendType, updateType} = this.props;
    return (
      <div className={"event-registrant-type-container"}>
        <div
          className={"event-registrant-type-option " + (type === "REGISTRATION" ? 'selected' : '')}
          onClick={() => updateType('REGISTRATION')}>{_('REGISTRATION')}
          <div className='event-stats-progress-filter-wrapper' >
          </div>
        </div>

        <div
          className={"event-registrant-type-option " + (type === "CA" ? 'selected' : '')}
          onClick={() => updateType('CA')}>{_('CA')}
          <div className='event-stats-progress-filter-wrapper'>
            <div className='event-stats-progress-filter-bar'/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter.js